import type {Household} from "@/src/modules/households/types";

import type {VehicleHouseHoldEmbed} from "../types";

/** Maps vehicle `house_hold` embed to household fields for locked safelisting create. */
export function vehicleHouseHoldToHousehold(
  embed: VehicleHouseHoldEmbed | null | undefined,
  fallbackName?: string,
): Pick<
  Household,
  "house_hold_id" | "name" | "amenity_access_restricted" | "restricted_amenities"
> | null {
  if (embed?.house_hold_id == null) return null;
  return {
    house_hold_id: embed.house_hold_id,
    name: embed.name?.trim() || fallbackName?.trim() || `Household #${embed.house_hold_id}`,
    amenity_access_restricted: embed.amenity_access_restricted,
    restricted_amenities: embed.restricted_amenities,
  };
}
